import { render, staticRenderFns } from "./CostTrends.vue?vue&type=template&id=23e83eb9&scoped=true&"
import script from "./CostTrends.vue?vue&type=script&lang=js&"
export * from "./CostTrends.vue?vue&type=script&lang=js&"
import style0 from "./CostTrends.vue?vue&type=style&index=0&id=23e83eb9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e83eb9",
  null
  
)

export default component.exports